import { Content } from '@visikon/core-models';
import { BlockCard } from './BlockCard';

export const BlockCards = ({ items, language, onClick }: { items: Content.Block[], language: Content.LanguageCode, onClick: (id: string) => void }) => (
    <div className="ui cards">
      {items.map((item) => (<BlockCard key={item._id} lang={language} block={item} onClick={() => onClick(item._id)} />))}
    </div>
  );
